// extracted by mini-css-extract-plugin
module.exports = {"magicMenu":"MagicMenu_magicMenu__9tjwd","magicItem":"MagicMenu_magicItem__XhuAK","p":"MagicMenu_p__3hdTA"};